import { render, staticRenderFns } from "./factor.vue?vue&type=template&id=a152767c&scoped=true"
import script from "./factor.vue?vue&type=script&lang=js"
export * from "./factor.vue?vue&type=script&lang=js"
import style0 from "./factor.vue?vue&type=style&index=0&id=a152767c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152767c",
  null
  
)

export default component.exports